import { css } from 'styled-components';
import { ROOT_BASE } from '../themes/constants';
/**
 * Calculates and returns a line-height
 * @private
 * @param fontSize {number}
 * @param baseLineHeight {number}
 * @returns {number}
 */
const calculateLineHeight = (fontSize, baseLineHeight) => {
    if (typeof fontSize !== 'number') {
        throw new Error(`Calculate line height - Parameter fontSize must be of type number, ${typeof fontSize} (${fontSize}) was passed.`);
    }
    else {
        return Math.floor(fontSize * baseLineHeight);
    }
};
/**
 * Higher Order Function to compose lineHeight function with a given base
 * @param baseLineHeight {number}
 * @returns {Function}
 */
export const withBaseLineHeight = baseLineHeight => {
    if (typeof baseLineHeight !== 'number') {
        throw new Error(`With base line height - Parameter baseLineHeight must be of type number, ${typeof baseLineHeight} (${baseLineHeight}) was passed.`);
    }
    return fontSize => {
        return calculateLineHeight(fontSize, baseLineHeight);
    };
};
export const noop = () => {
    return;
};
/**
 * For the specified media query, returns a tag function that can be used to
 * automatically wrap the tagged template literal in its media query.
 *
 * https://github.com/morajabi/styled-media-query
 * @param {string} query The string or template literal containing the media
 *   query features.
 */
export const mediaQuery = query => (...rules) => css `
      @media ${query} {
        ${css(...rules)};
      }
    `;
/**
 * Converts `px` values to `rem` according a given base
 *
 * @param {number} px
 * @param {number} base default is 16
 */
export const rem = (px, base = ROOT_BASE) => {
    return `${px / base}rem`;
};
/**
 * Converts `px` values to `em` according a given base
 *
 * @param {number} px
 * @param {number} base default is 16
 */
export const em = (px, base = ROOT_BASE) => {
    return `${px / base}em`;
};
